import css from 'styled-jsx/css';

const styles = css.global`#duvidas-frequentes25-canais {
  padding: 48px 0;
  overflow: hidden;
}

#duvidas-frequentes25-canais .canais-principal {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

#duvidas-frequentes25-canais .canais-principal .canais-textos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#duvidas-frequentes25-canais .canais-textos .canais-titulo {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}

#duvidas-frequentes25-canais .canais-textos .canais-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#duvidas-frequentes25-canais .canais-carrossel .slide {
  border-radius: 4px;
  background: #FFF;
  box-shadow: 0px 4px 8px 0px rgba(34, 34, 34, 0.12);
  width: 240px;
  height: 138px;
  margin-right: 24px;
  flex: 0 0 240px;
}

#duvidas-frequentes25-canais .canais-carrossel .slide-contain {
  width: 240px;
  height: 138px;
  cursor: pointer;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
}

#duvidas-frequentes25-canais .canais-carrossel .slide-contain .qrcode-whatsapp {
  position: absolute;
  width: 110px;
  right: 16px;
}

#duvidas-frequentes25-canais .canais-carrossel .slide-contain .qrcode-whatsapp img {
  width: 110px;
}

#duvidas-frequentes25-canais .canais-carrossel .canais-card-img-titulo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

#duvidas-frequentes25-canais .canais-carrossel .canais-card-titulo {
  color: #444;
  font-family: "SantanderMicroText";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}

#duvidas-frequentes25-canais .canais-carrossel .canais-card-titulo ins {
  text-decoration: none;
}

#duvidas-frequentes25-canais .canais-carrossel .canais-card-link {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

#duvidas-frequentes25-canais .canais-carrossel .canais-card-link.link-email {
  font-size: 16px;
}

#duvidas-frequentes25-canais .canais-carrossel .home-pagination {
  margin-top: 24px;
  max-width: 272px;
}

#duvidas-frequentes25-canais .home-pagination .embla__prev {
  background-image: url(assets/renegociacao25/canais/ic_arrow_l.svg);
}

#duvidas-frequentes25-canais .home-pagination .embla__next {
  background-image: url(assets/renegociacao25/canais/ic_arrow_r.svg);
}

#duvidas-frequentes25-canais .home-pagination .embla__prev, 
#duvidas-frequentes25-canais .home-pagination .embla__next {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}



@media (min-width: 992px) {
  #duvidas-frequentes25-canais {
    background: #FBFBFB;
    padding: 40px 0;
    overflow: hidden;
  }

  #duvidas-frequentes25-canais .canais-principal {
    padding-bottom: 24px;
  }
  
  #duvidas-frequentes25-canais .canais-carrossel .canais-card-titulo ins {
    display: none;
  }
  #duvidas-frequentes25-canais .home-pagination {
    display: none;
  }
}`;

export default styles;